import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { capitalize, find } from "lodash";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box } from "@mui/system";
import { TypeSpecimenOutlined } from "@mui/icons-material";
import { IconButton, Typography, Chip } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import Pause from "@mui/icons-material/Pause";
import SmartCheckCard from "../../Components/Card/AssetUI/SmartCheckCard";
import { getWords } from "../../Js/Common";
import { currentAssetSliceActions } from "../../Store/Slices/CurrentAssetSlice";
import { unicodeToString } from "../../Js/Common";
import AudioButton from "../../Components/Media/AudioButton";
import RecordButton from "../../Components/Media/RecordButton";

import Stack from "@mui/material/Stack";
import Slider from "@mui/material/Slider";
import VolumeDown from "@mui/icons-material/VolumeDown";
import VolumeUp from "@mui/icons-material/VolumeUp";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "practice",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 0,
};

const WordsInSlide = (props) => {
  const classes = useStyles();
  // Hooks
  const dispatch = useDispatch();

  // State
  let [userAnswer, setUserAnswer] = useState([]);
  let [localAudios, setLocalAudios] = useState([]);
  let [logObj, setLogObj] = useState(initLogObj);
  let [words, setWords] = useState([]);
  let [content, setContent] = useState([]);
  let [currentPOS, setCurrentPOS] = useState(0);
  let [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  let [isPlaying, setIsPlaying] = useState(false);
  let [itemAudios, setItemAudios] = useState([]);
  let [smartCheckResult, setSmartCheckResult] = useState([]);
  let [infoShow, setInfoShow] = useState(true);
  let [attempts, setAttempts] = useState([]);
  let [aiEnable, setAiEnable] = useState(true);
  let [playbackValue, setPlaybackValue] = useState(1);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

  useEffect(() => {
    let innerFun = async () => {
      if (props.content) {
        console.log("props.content",props.content);
        let wordsData = await getWords(props.content.epage.options.content);
        let seqArray = [];
        console.log("wordsData.data", wordsData.data);
        if (props.content.epage.options.contentInSeq) {
          seqArray = props.content.epage.options.contentInSeq.map((val) => {
            let foundObj = find(wordsData.data, { uid: val.uid });
            return foundObj;
          });
        } else {
          seqArray = props.content.epage.options.content.map((val) => {
            let foundObj = find(wordsData.data, { uid: val });
            return foundObj;
          });
        }
        setWords(seqArray);
        setUserAnswer(
          new Array(props.content.epage.options.content.length).fill(false)
        );
        setLocalAudios(
          new Array(props.content.epage.options.content.length).fill(null)
        );
        setSmartCheckResult(
          new Array(props.content.epage.options.content.length).fill(null)
        );
        setAttempts(
          new Array(props.content.epage.options.content.length).fill(0)
        );

        // if (
        //   props.content.epage.options?.ai_enable != undefined &&
        //   !fromCompletedTab
        // ) {
        //   setAiEnable(props.content.epage.options.ai_enable);
        // }
        let actualAnswers = props.content.epage.options.content.map((val) => {
          if (val.answer) return JSON.parse(val.answer);
          else return JSON.parse("false");
        });
        setLogObj({
          ...logObj,
          assetType: {
            ...logObj.assetType,
            value: props.content.info.asset_type_alias,
          },
          actualAnswer: actualAnswers,
        });
      }
    };
    innerFun();

    return () => {
      setContent([]);
      setWords([]);
      setTimeout(() => {
        setCurrentSlideIndex(0);
        setCurrentPOS(0);
      }, 500);
    };
  }, [props.content]);

  // useEffect(() => {
  //   if (fromCompletedTab) {
  //     setAiEnable(false);
  //   }
  // }, [fromCompletedTab]);

  // useEffect(() => {
  //   dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
  //   dispatch(currentAssetSliceActions.setShowAnswer(false));
  // }, [logObj]);

  useEffect(() => {
    if (words && words.length > 0 && content && content.length == 0) {
      if (typeof words[0]["content"] == "string") {
        setContent(JSON.parse(words[0]["content"]));
      } else {
        setContent(words[0]["content"]);
      }
    }
  }, [words]);

  // useEffect(() => {
  //   if (showAnswer && assetLogObj && assetLogObj.actualAnswer) {
  //     setUserAnswer(assetLogObj.actualAnswer);
  //     let firstTrueIndex = assetLogObj.actualAnswer.indexOf(true);
  //   }
  // }, [showAnswer, assetLogObj]);

  useEffect(() => {
    return () => {
      setUserAnswer([]);
    };
  }, []);

  useEffect(() => {
    if (content && content[currentPOS]) {
      let mediaFlags = content[currentPOS].items.map((val) => {
        return val.list.map((val1) => {
          return false;
        });
      });
      setItemAudios(mediaFlags);
    }
  }, [content, currentPOS]);

  const setCurrentWord = (index, item) => {
    if (words) {
      if (typeof words[index]["content"] == "string") {
        setContent(JSON.parse(words[index]["content"]));
      } else {
        setContent(words[index]["content"]);
      }
    }
    setCurrentSlideIndex(index);
    setCurrentPOS(0);
  };

  const updateAudioFlags = (audiostatus, index1, index2) => {
    console.log("updateAudioFlags", audiostatus);
    let itemAudiosTemp = itemAudios.map((val, index) => {
      return val.map((val1, innerIndex) => {
        if (index == index1 && innerIndex == index2) {
          return audiostatus;
        } else {
          return val1;
        }
      });
    });
    setItemAudios(itemAudiosTemp);
  };

  // const updateUserAnswer = (index) => {
  //   if (!showAnswer && !attempted) {
  //     let newArray = [...userAnswer];
  //     newArray[index] = !newArray[index];
  //     setUserAnswer(newArray);
  //     //dispatch(currentAssetSliceActions.setCurrentAttemptData(newArray));
  //   }
  // };

  const setAudioLinks = (audioLink, index) => {
    let newArray = [...localAudios];
    newArray[index] = audioLink;
    setLocalAudios(newArray);
    if (userInfo.rolesInfo.title.toLowerCase() == "trainer") {
      //dispatch(currentAssetSliceActions.setCurrentAttemptData(newArray));
    }
  };

  const setFiles = (filename, index) => {
    console.log("LLfilenamefilename", filename, index);
    if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
      let newArray = [...userAnswer];
      newArray[index] = filename;
      setUserAnswer(newArray);
      //dispatch(currentAssetSliceActions.setCurrentAttemptData(newArray));
    }
  };

  const setSmartCheck = (result, filename, index) => {
    console.log("filename", result, filename, index);
    if (result != "site_server") {
      if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
        let newArray = [...userAnswer];
        newArray[index] = filename;
        setUserAnswer(newArray);
        //dispatch(currentAssetSliceActions.setCurrentAttemptData(newArray));

        let attemptArray = [...attempts];
        attemptArray[index] = attemptArray[index] + 1;
        setAttempts(attemptArray);
      }
      console.log("filename", filename);
      let newArray = [...smartCheckResult];
      let updateFlag = true;
      if (
        newArray[index] &&
        +newArray[index]["utterance"][0]["nativeness_score"] >
          result["utterance"][0]["nativeness_score"]
      ) {
        updateFlag = false;
      }

      newArray[index] = result;

      console.log("newArray", newArray);
      if (updateFlag && aiEnable) {
        //dispatch(currentAssetSliceActions.setSmartCheckData(newArray));
      }
      setSmartCheckResult(newArray);
    } else {
      console.log("filename", filename);
      if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
        let newArray = [...userAnswer];
        newArray[index] = filename;
        setUserAnswer(newArray);
        //dispatch(currentAssetSliceActions.setCurrentAttemptData(newArray));
      }
    }
  };

  return (
    <>
      {props.content && words && words[currentSlideIndex] && (
        <Box sx={{ height: "58vh" }}>
          <Grid
            container
            sx={{
              flexDirection: "row",
              flexFlow: "wrap",
              justifyContent: "center",
            }}
          >
            <Grid item xs={12}>
              <Box sx={{ paddingTop: 0 }}>
                <Grid
                  container
                  sx={{
                    flexDirection: "row",
                    mt: 1,
                    justifyContent: "center",
                    alignItems: "center",
                    height: "15vh",
                    backgroundColor: "#F5F7FF",
                    borderRadius: 8,
                  }}
                >
                  <Grid item xs={1}>
                    {currentSlideIndex > 0 && (
                      <IconButton
                        sx={{
                          color: "primary.main",
                          ml: 4,
                        }}
                        onClick={() => {
                          setCurrentSlideIndex(currentSlideIndex - 1);
                        }}
                      >
                        <NavigateBeforeIcon sx={{ fontSize: "2.4vw" }} />
                      </IconButton>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={10}
                    sx={{
                      position: "relative",
                      cursor: "pointer",
                      py: 4,
                      textAlign: "center",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "15vh",
                    }}
                  >
                    <Carousel
                      showIndicators={false}
                      onChange={setCurrentWord}
                      showArrows={false}
                      selectedItem={currentSlideIndex}
                      showStatus={false}
                      emulateTouch={true}
                    >
                      {words.map((word, index) => {
                        return (
                          <Box
                            sx={{
                              display: "flex",
                              textAlign: "center",
                              justifyContent: "center",
                              alignContent: "center",
                              position: "relative",
                            }}
                          >
                            <Typography
                              sx={{
                                color: "primary.main",
                                fontSize: "2rem",
                                fontWeight: "700",
                                "@media (min-width: 1636px)": {
                                  fontSize: "4rem",
                                },
                              }}
                            >
                              {word.word_phrase ? word.word_phrase : ""} |
                            </Typography>
                            <Typography
                              sx={{
                                color: "primary.main",
                                "@media (min-width: 1636px)": {
                                  fontSize: "2rem",
                                },
                              }}
                            >
                              <sup>
                                CEFR{" "}
                                {content &&
                                content[0] &&
                                content[0]["cefr_level"]
                                  ? content[0]["cefr_level"]
                                  : ""}
                              </sup>
                            </Typography>
                          </Box>
                        );
                      })}
                    </Carousel>
                    <Box
                      sx={{
                        position: "absolute",
                        top: "80%",
                        left: "40%",
                        // left: smartCheckResult ? "28%" : "33%",
                        // transform: "translatey(50%)",
                        // transform: "translateX(50%)",
                        // "@media (min-width: 1636px)": {
                        //   left: smartCheckResult ? "39.5%" : "41.5%",
                        // },
                      }}
                    >
                      {content &&
                        content[0] &&
                        content[0]["media"] &&
                        content[0]["media"]["audio"] && (
                          <>
                            <AudioButton
                              wordAudio={content[currentPOS]["media"]["audio"]}
                              playStatus={(status) => setIsPlaying(status)}
                              playbackValue={playbackValue}
                            >
                              <IconButton
                                sx={{
                                  mx: 1,
                                  border: 1,
                                  borderColor: "#EFEFEF",
                                  backgroundColor: "#FFFFFF",
                                  boxShadow: 2,
                                  color: "primary.main",
                                 
                                }}
                              >
                                {isPlaying ? (
                                  <Pause
                                    sx={{
                                      "@media (min-width: 1636px)": {
                                        fontSize: "2rem",
                                      },
                                    }}
                                  />
                                ) : (
                                  <PlayArrowIcon
                                    sx={{
                                      "@media (min-width: 1636px)": {
                                        fontSize: "2rem",
                                      },
                                    }}
                                  />
                                )}
                              </IconButton>
                            </AudioButton>
                            <RecordButton
                              textToCheck={
                                words[currentSlideIndex].word_phrase
                                  ? words[currentSlideIndex].word_phrase
                                  : ""
                              }
                              alreadyRecorded={
                                localAudios.length > 0 &&
                                localAudios[currentSlideIndex]
                                  ? localAudios[currentSlideIndex]
                                  : null
                              }
                              recordedAudio={(audio) => {
                                setAudioLinks(audio, currentSlideIndex);
                              }}
                              smartCheck={(data, filename) => {
                                setSmartCheck(
                                  data,
                                  filename,
                                  currentSlideIndex
                                );
                                if (typeof data != "string") {
                                  setInfoShow(false);
                                }
                              }}
                              uploadedAudioName={(filename) => {
                                setFiles(filename, currentSlideIndex);
                              }}
                              checkOnPause={aiEnable}
                              uploadOnPause={!aiEnable}
                              resetComponent={true}
                              index={currentSlideIndex}
                              disabled={
                                userInfo.rolesInfo.title.toLowerCase() ==
                                  "learner" &&
                                smartCheckResult[currentSlideIndex] &&
                                +smartCheckResult[currentSlideIndex]
                                  ?.utterance[0]?.nativeness_score >=
                                  +process.env
                                    .REACT_APP_SMART_CHECK_DISABLE_PERCENTAGE
                              }
                              audioDisable={false}
                            ></RecordButton>
                          </>
                        )}
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={1}
                    sx={{
                      "@media (min-width: 1636px)": {
                        textAlign: "right",
                        pr: 3,
                      },
                    }}
                  >
                    {currentSlideIndex < words.length - 1 && (
                      <IconButton
                        sx={{
                          color: "primary.main",
                        }}
                        onClick={() => {
                          setCurrentSlideIndex(currentSlideIndex + 1);
                        }}
                      >
                        <NavigateNextIcon sx={{ fontSize: "2.4vw" }} />
                      </IconButton>
                    )}
                  </Grid>
                </Grid>
              </Box>
              <Box sx={{ pa: 0 }}>
                <Grid
                   
                  container
                  sx={{
                    height: "36vh",
                    mt: 4,
                    overflow: "auto",
                    "@media (min-width: 1636px)": {
                      height: "38vh",
                    },
                  }}
                >
                  {/* <Grid container justifyContent={"center"} mb={1}>
                    <Stack
                      spacing={2}
                      direction="row"
                      sx={{ alignItems: "center", mb: 1, width: "25vw" }}
                    >
                      <Typography>Slow</Typography>
                      <Slider
                        aria-label="Temperature"
                        defaultValue={1}
                        valueLabelDisplay="auto"
                        shiftStep={1}
                        step={0.2}
                        marks
                        min={0.6}
                        max={1}
                        onChange={(event, sval) => {
                          console.log("SSS", sval);
                          setPlaybackValue(sval);
                        }}
                        value={playbackValue}
                      />
                      <Typography>Regular</Typography>
                    </Stack>
                  </Grid> */}
                  <Grid item xs={12} textAlign={"center"}>
                    {content &&
                      content[currentPOS] &&
                      content.map((val, posindex) => {
                        return (
                          <Chip
                            label={capitalize(unicodeToString(val.pos))}
                            component="a"
                            clickable
                            color="primary"
                            variant={
                              posindex == currentPOS ? "contain" : "outlined"
                            }
                            onClick={() => setCurrentPOS(posindex)}
                            sx={{
                              ml: 1,
                              fontSize: "0.7rem",
                              fontWeight: "600",
                              "@media (min-width: 1636px)": {
                                fontSize: "1rem",
                              },
                            }}
                          />
                        );
                      })}
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container sx={{ mt: 1 }}>
                      <Grid
                        item
                        xs={6}
                         
                        sx={{
                          textAlign: "center",
                          borderRight: 1,
                          borderColor: "#EAECEE",
                          width: "100%",
                          backgroundColor: "#FFF",
                        }}
                      >
                        {content &&
                          content[currentPOS] &&
                          content[currentPOS]["media"] &&
                          content[currentPOS]["media"]["image"] && (
                            <img
                              src={`${sessionStorage.getItem(
                                "media_url"
                              )}words_media/image/${
                                content[currentPOS]["media"]["image"]
                              }`}
                              width="50%"
                              style={{ borderRadius: 10 }}
                            />
                          )}
                      </Grid>
                      <Grid
                        item
                        xs={6}
                         
                        sx={{
                          height: "26vh",
                          overflow: "auto",
                          pl: 3,
                          "@media (min-width: 1636px)": {
                            height: "28vh",
                          },
                        }}
                      >
                        {content &&
                          content[currentPOS] &&
                          content[currentPOS]["items"] &&
                          content[currentPOS]["items"].map((item, index1) => {
                            return (
                              <>
                                <Typography
                                  sx={{
                                    color: "primary.main",
                                    fontWeight: "700",
                                    fontSize: "0.9rem",
                                    mt: index1 > 0 ? 2 : 0,
                                    "@media (min-width: 1636px)": {
                                      fontSize: "1.6rem",
                                    },
                                  }}
                                  key={`${index1}_item`}
                                >
                                  {item.title
                                    ? unicodeToString(item.title)
                                    : ""}
                                </Typography>
                                {item.list &&
                                  item.list.map((textObj, index2) => {
                                    return (
                                      <Grid container>
                                        <Typography
                                          sx={{
                                            color: "primary.main",
                                            fontWeight: "500",
                                            fontSize: "0.9rem",
                                            alignContent: "space-evenly",
                                            "@media (min-width: 1636px)": {
                                              fontSize: "1.4rem",
                                            },
                                          }}
                                        >
                                          {textObj.text
                                            ? unicodeToString(textObj.text)
                                            : ""}
                                        </Typography>
                                        {textObj["media"] &&
                                          textObj["media"]["audio"] && (
                                            <AudioButton
                                              wordAudio={
                                                textObj["media"]["audio"]
                                              }
                                              playStatus={(status) =>
                                                updateAudioFlags(
                                                  status,
                                                  index1,
                                                  index2
                                                )
                                              }
                                            >
                                              <IconButton
                                                size="small"
                                                sx={{
                                                  mx: 1,
                                                  border: 1,
                                                  borderColor: "#EFEFEF",
                                                  backgroundColor: "#FFFFFF",
                                                  boxShadow: 2,
                                                  color: "primary.main",
                                               
                                                }}
                                              >
                                                {itemAudios[index1] &&
                                                itemAudios[index1][index2] ? (
                                                  <Pause
                                                    sx={{
                                                      "@media (min-width: 1636px)":
                                                        {
                                                          fontSize: "2rem",
                                                        },
                                                    }}
                                                  />
                                                ) : (
                                                  <PlayArrowIcon
                                                    sx={{
                                                      "@media (min-width: 1636px)":
                                                        {
                                                          fontSize: "2rem",
                                                        },
                                                    }}
                                                  />
                                                )}
                                              </IconButton>
                                            </AudioButton>
                                          )}
                                      </Grid>
                                    );
                                  })}
                              </>
                            );
                          })}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
              {smartCheckResult &&
                smartCheckResult.length > 0 &&
                smartCheckResult[currentSlideIndex] &&
                aiEnable && (
                  <SmartCheckCard
                    smartCheckResult={smartCheckResult[currentSlideIndex]}
                    align={"center"}
                  ></SmartCheckCard>
                )}
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default WordsInSlide;
